import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";

const s3Config = {
  region: "us-east-1",
  credentials: {
    accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
    secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
  },
  endpoint: "https://s3-noi.aces3.ai/",
  forcePathStyle: true,
};
console.log(s3Config);


const s3Client = new S3Client(s3Config);
export const uploadFileToS3 = async ({
  file,
    bucketName = "invent-co-new",
  dirName = "teamAsOne/upload",
}) => {
  const key = dirName + "/" + file.name;
  const params = {
    Bucket: bucketName,
    Key: key,
    Body: file,
  };
  console.log(params);
  

  const upload = new Upload({
    client: s3Client,
    params: params,
  });

  try {
    const data = await upload.done();
    return data;
  } catch (err) {
    throw err;
  }
};